__turbopack_context__.v({
  "celebration": "Milestone-module__uCNFwa__celebration",
});
